import { render, staticRenderFns } from "./MarkDialog.vue?vue&type=template&id=37002c81&scoped=true&"
import script from "./MarkDialog.vue?vue&type=script&lang=js&"
export * from "./MarkDialog.vue?vue&type=script&lang=js&"
import style0 from "./MarkDialog.vue?vue&type=style&index=0&id=37002c81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37002c81",
  null
  
)

export default component.exports